import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private BASE_URL = environment.apiUrl;

  private httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) {}

  public request(
    method: string,
    url: string,
    data?: any,
    options?: any
  ): Observable<any> {
    const requestOptions = {
      ...options,
      headers: options?.headers || this.httpHeaders,
    };

    if (method === 'GET') {
      return this.http.get(this.BASE_URL + url, requestOptions);
    } else if (method === 'POST') {
      return this.http.post(this.BASE_URL + url, data, requestOptions);
    } else if (method === 'PUT') {
      return this.http.put(this.BASE_URL + url, data, requestOptions);
    } else if (method === 'PATCH') {
      return this.http.patch(this.BASE_URL + url, data, requestOptions);
    } else if (method === 'DELETE') {
      return this.http.delete(this.BASE_URL + url, requestOptions);
    }

    throw new Error(`Unsupported HTTP method: ${method}`);
  }

  public get(url: string): Observable<any> {
    return this.http
      .get(this.BASE_URL + url, {
        observe: 'response',
        headers: this.httpHeaders,
      })
      .pipe(map((res) => res.body));
  }

  public delete(url: string): Observable<any> {
    return this.http
      .delete(this.BASE_URL + url, {
        observe: 'response',
        headers: this.httpHeaders,
      })
      .pipe(map((res) => res.body));
  }

  public post(url: string, data: any): Observable<any> {
    return this.http
      .post(this.BASE_URL + url, data, {
        observe: 'response',
        headers: this.httpHeaders,
      })
      .pipe(map((res) => res.body));
  }

  public put(url: string, data: any): Observable<any> {
    return this.http
      .put(this.BASE_URL + url, data, {
        observe: 'response',
        headers: this.httpHeaders,
      })
      .pipe(map((res) => res.body));
  }

  public patch(url: string, data: any): Observable<any> {
    return this.http
      .patch(this.BASE_URL + url, data, {
        observe: 'response',
        headers: this.httpHeaders,
      })
      .pipe(map((res) => res.body));
  }

  public downloadFile(url: string): Observable<Blob> {
    return this.http.get(this.BASE_URL + url, {
      responseType: 'blob',
    });
  }
}
